import axios from "axios";
import config from "../config"
import {getDoctorToken} from '../utils'

const getBookmarkArticlesApi = async () => { 
  const response = await axios({
    url: `${config.api.base_url}article/bookmarked`,
    method: "get", 
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getDoctorToken()}`
    },
  });
  console.log("response",response);
  return response;
};

export default getBookmarkArticlesApi;
